import { GetToken } from './GetAuthToken';

export enum Method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH',
}

interface Header {
    // TODO replace usage of this type with a better type that probably exists
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export const AuthRequest = async (url: string, method: Method, headers?: Header, body?: object) => {
    //Get token and append to Authorization header before making request
    if (!headers) {
        headers = {};
    }

    const token = GetToken();
    headers.Authorization = `Bearer ${token}`;

    //Send request
    const res = await fetch(url, {
        method: method,
        mode: 'cors',
        headers: headers,
        body: body ? JSON.stringify(body) : null,
    });
    return res;
};
